module.exports = __webpack_public_path__ + "static/media/posicionador-02.022e75d9.png";